/*
 * Copyright (c) 2024 Potentially Ltd
 *
 * Please see distribution for license
 */

import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment/moment';

export const DATE_PICKER_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class DateRangeAdapter extends NativeDateAdapter {
  public override format(date: Date, displayFormat: string): string {
    return moment(date).format(displayFormat);
  }
}
